<template>
  <div class="second-header">
    <section id="subheader">
      <div class="container">
        <div class="row container-header">
          <div class="col-md-12 text-center mt-4 mb-2">
            <img
              :src="
                `${
                  restaurant.logo
                    ? 'htttp://localhost:3333/logos/' + restaurant.logo
                    : 'htttp://localhost:3333/logos/logo.png'
                }`
              "
              style="width:
            110px;object-fit: fill;"
              alt="logo"
              class="logo_second"
            />
          </div>
          <div class="col-md-12">
            <h2 class="name_restaurant">
              <span>{{ restaurant.name }}</span>
            </h2>
          </div>
          <div class="d-flex justify-content-center" style="width: 100%">
          
            <p @click="sendMessage" class="description_second_header">
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Sint
              aliquam eius ut corporis. Adipisci error obcaecati neque impedit
              non nesciunt odit sequi quibusdam, dolores voluptate repudiandae a
              alias molestiae omnis.
            </p>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
const topicName = 'order'

export default {
  props: ["restaurant", "smaler", "currentLang", "newItem", "currentLang"],

  data() {
    return {
      // apiPath1: apiPath1,
      name: "name of the menu",
    };
  },
  methods: {
    sendMessage(){
      // this.$ws.$emitToServer(topicName, 'message', {message: 'message'})
    }
  },
  created(){
    
  },
  watch: {
    // name(newVal) {
    //   this.changeName(newVal);
    // }
  },
  mounted() {},
};
</script>
<style>
.description_second_header {
  text-align: center;
  width: 740px;
  padding: 40px;
  font-size: 12px;
  color: black;
}
#subheader {
  width: 100%;
  background: #fff;
  text-align: center;
  padding-top: 4em;
}
#subheader h1 {
  color: #eceff3;
  margin-top: 140px;
  font-size: 36px;
}
#subheader h2 {
  display: block;
  letter-spacing: normal;
  font-family: "Allura";
  font-size: 28px;
  color: #ca8e46;
}
#subheader span {
  letter-spacing: 2px;
  display: inline-block;
  font-size: 15px;
  margin-top: 88px;
  color: #fff;
}

#subheader h2 span {
  font-size: 30px;
  padding-top: 0;
  margin-top: 10px;
}

#subheader h2 {
  line-height: 0.5;
  text-align: center;
}
#subheader h2 span {
  display: inline-block;
  position: relative;
  display: inline-block;
  position: relative;
  color: #ca8e46;
  font-size: 50px;
}
#subheader h2 span:before,
#subheader h2 span:after {
  content: "";
  position: absolute;
  height: 1px;
  border-top: 1px solid #ca8c68;
  top: 6px;
  width: 200px;
}
#subheader h2 span:before {
  right: 100%;
  margin-right: 15px;
}
#subheader h2 span:after {
  left: 100%;
  margin-left: 15px;
}

.de_light .de_tab.tab_style_2 .de_nav {
  margin: 0 auto;
  text-align: center;
}
@media screen and (max-width: 580px) {
  .second-header #subheader {
    padding-top: 0em !important;
  }
  .second-body #content {
    padding: 0px 0 40px 0 !important;
  }
  .logo_second {
    width: 120px;
    margin-bottom: 1em;
  }
  .description_second_header {
    padding: 20px 20px;
  }
  .container-header {
    width: 100%;
    margin: 0;
    padding: 0;
  }
  .name_restaurant {
    overflow: hidden;
  }
}

.logo_second {
  width: 150px;
}
</style>
